import Api from './Api'

export default {
  loadByType (queryParams) {
    return Api().get('/instillinger/label/tree.json', {
      params: {
        type: queryParams.type || null,
        sort: queryParams.sort || 'Labelid',
        direction: queryParams.direction || 'ASC'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/LabelService.js